
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseService } from "../BaseService";
import { UrlService } from "../UrlService";

@Injectable()
export class CompanyPhoneNumberService {
	private url: string;

	constructor(
		private myBaseService: BaseService,
		private urlService: UrlService
	) {
		this.url = urlService.getURL('CompanyPhoneNumber');
	}

	loadAll(): Observable<TooBig4Car.Logic.CompanyPhoneNumber[]> {
		return this.myBaseService.loadAll(this.url);
	}
	searchAreaCode(areaCode: string): Observable<string[]> {
		return this.myBaseService.loadAll(this.url + '/Search/' + (areaCode));
	}
	save(tempItem: TooBig4Car.Logic.CompanyPhoneNumber): Observable<TooBig4Car.Logic.CompanyPhoneNumber> {
		return this.myBaseService.save(tempItem, this.url);
	}
	deleteItem(id: System.Guid): Observable<boolean> {
		return this.myBaseService.deleteItem(id, this.url);
	}
	getEdit(id: System.Guid): Observable<TooBig4Car.Logic.CompanyPhoneNumber> {
		return this.myBaseService.getEdit(id, this.url);
	}
	get(id: System.Guid): Observable<TooBig4Car.Logic.CompanyPhoneNumber> {
		return this.myBaseService.get(id, this.url);
	}
	search(searchTerm: string): Observable<TooBig4Car.Logic.CompanyPhoneNumber[]> {
		return this.myBaseService.post(searchTerm, this.url + '/Search', false);
	}
}

